import { ResponsiveBar } from '@nivo/bar';

export const MyResponsiveBar = ({ data, keys, type, Of }:any) => {

    const DataOfBar: any[]=[];

    const DataDetails: string[]=[];

    if(type==="Req"){
        data.forEach((el:any,index:number)=>{
            if(index < data.length-3){
                let name=el.branchName.split(" ");
                if(Of==="Branch"){
                    DataDetails.push(`${name[0][0]+"-"+name[1][1]} ->  ${el.branchName}`);
                } else {
                    DataDetails.push(`${name[0][0]} ->  ${el.branchName}`);
                }
                
                DataOfBar.push({
                    "branchName": Of==="Branch"?name[0][0]+"-"+name[1][1] : name[0][0],
                    "Total Requirement": el.totalRequirement,
                    "Total RequirementColor": "hsl(140, 70%, 50%)",
                    "Total Allocation": el.totalAllocation,
                    "Total AllocationColor": "hsl(41, 70%, 50%)",
                    "Total Served": el.totalServices,
                    "Total ServicesColor": "hsl(230, 70%, 50%)",
                    "Total Submission": el.serving,
                    "ServingColor": "hsl(61, 70%, 50%)"
                });
            }
        });
    }

    if(type==="Sub"){
        data.forEach((el:any,index:number)=>{
            if(index < data.length-3){
                let name=el.branchName.split(" ");
                if(Of==="Branch"){
                    DataDetails.push(`${name[0][0]+"-"+name[1][1]} ->  ${el.branchName}`);
                } else {
                    DataDetails.push(`${name[0][0]} ->  ${el.branchName}`);
                }
                
                DataOfBar.push({
                    "branchName": Of==="Branch"?name[0][0]+"-"+name[1][1] : name[0][0],
                    "Total Submission": el.totalSubmission,
                    "Total SubmissionColor": "hsl(140, 70%, 50%)",
                    "Total Sales Rejected": el.totalSalesRejected,
                    "Total Sales RejectedColor": "hsl(41, 70%, 50%)",
                    "Total PV Rejected": el.totalPVRejected,
                    "Total PV RejectedColor": "hsl(230, 70%, 50%)",
                    "Total End Client Submission": el.totalEndClientSubmission,
                    "Total End Client SubmissionColor": "hsl(61, 70%, 50%)"
                });
            }
        });
    }

    if(type==="ECI"){
        data.forEach((el:any,index:number)=>{
            if(index < data.length-3){
                let name=el.branchName.split(" ");
                if(Of==="Branch"){
                    DataDetails.push(`${name[0][0]+"-"+name[1][1]} ->  ${el.branchName}`);
                } else {
                    DataDetails.push(`${name[0][0]} ->  ${el.branchName}`);
                }
                
                DataOfBar.push({
                    "branchName": Of==="Branch"?name[0][0]+"-"+name[1][1] : name[0][0],
                    "Total ECI": el.totalECI,
                    "Total ECIColor": "hsl(140, 70%, 50%)",
                    "Total Backout ECI": el.totalBackoutECI,
                    "Total Backout ECIColor": "hsl(41, 70%, 50%)",
                    "Total Confirmed ECI": el.totalConfirmedECI,
                    "Total Confirmed ECIColor": "hsl(230, 70%, 50%)",
                    "Total Rescheduled ECI": el.totalRescheduledECI,
                    "Total Rescheduled ECIColor": "hsl(61, 70%, 50%)"
                });
            }
        });
    }

    if(type==="PO"){
        data.forEach((el:any,index:number)=>{
            if(index < data.length-3){
                let name=el.branchName.split(" ");
                if(Of==="Branch"){
                    DataDetails.push(`${name[0][0]+"-"+name[1][1]} ->  ${el.branchName}`);
                } else {
                    DataDetails.push(`${name[0][0]} ->  ${el.branchName}`);
                }
                
                DataOfBar.push({
                    "branchName": Of==="Branch"?name[0][0]+"-"+name[1][1] : name[0][0],
                    "Total PO": el.totalPO,
                    "Total POColor": "hsl(140, 70%, 50%)",
                    "Total Running PO": el.totalRunningPO,
                    "Total Running POColor": "hsl(41, 70%, 50%)",
                    "Total Ended PO": el.totalEndedPO,
                    "Total Ended POColor": "hsl(230, 70%, 50%)",
                    "Total Fizzled PO": el.totalFizzledPO,
                    "Total Fizzled POColor": "hsl(61, 70%, 50%)"
                });
            }
        });
    }

    if(type==="Margin"){
        data.forEach((el:any,index:number)=>{
            if(index < data.length-3){
                let name=el.branchName.split(" ");
                if(Of==="Branch"){
                    DataDetails.push(`${name[0][0]+"-"+name[1][1]} ->  ${el.branchName}`);
                } else {
                    DataDetails.push(`${name[0][0]} ->  ${el.branchName}`);
                }
                
                DataOfBar.push({
                    "branchName": Of==="Branch"?name[0][0]+"-"+name[1][1] : name[0][0],
                    "Total Margin": el.totalMargin,
                    "Total MarginColor": "hsl(140, 70%, 50%)",
                    "Total Running Margin": el.totalRunningMargin,
                    "Total Running MarginColor": "hsl(41, 70%, 50%)",
                    "Total Ended Margin": el.totalEndedMargin,
                    "Total Ended MarginColor": "hsl(230, 70%, 50%)",
                    "Total Fizzled Margin": el.totalFizzledMargin,
                    "Total Fizzled MarginColor": "hsl(61, 70%, 50%)"
                });
            }
        });
    }

    return <div style={{height:"max-content"}}>
        <div style={{ display:"block",height:400}} className='border-1 surface-border pt-1'><ResponsiveBar
        data={DataOfBar}
        keys={keys}
        indexBy="branchName"
        margin={{ top: 50, right: 130, bottom: 50, left: 46 }}
        padding={0.3}
        groupMode="grouped"
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: false }}
        colors={{ scheme: 'nivo' }}
        defs={[
            {
                id: 'dots',
                type: 'patternDots',
                background: 'inherit',
                color: '#38bcb2',
                size: 4,
                padding: 1,
                stagger: true
            },
            {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: '#eed312',
                rotation: -45,
                lineWidth: 6,
                spacing: 10
            }
        ]}
        fill={[
            {
                match: {
                    id: 'fries'
                },
                id: 'dots'
            },
            {
                match: {
                    id: 'sandwich'
                },
                id: 'lines'
            }
        ]}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Branch Name',
            legendPosition: 'middle',
            legendOffset: 32
        }}
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Value',
            legendPosition: 'middle',
            legendOffset: -40
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        }}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={e=>e.id+": "+e.formattedValue+" in country: "+e.indexValue}
    />
    </div>
        {/* <div className='flex flex-wrap gap-3 border-1 surface-border pt-1 p-2 pb-5'>
            {DataDetails.map((el:string,index:number)=><p key={index} className='border-1 surface-border surface-ground pl-1 pr-1'>{el}</p>)}
        </div> */}
    </div>
}